import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { mergeBatteryIntoRobotComparison } from '../../CleaningReportsDashboard/cleaningReportBatteryMetrics';
import {
    estimateRobotProductMl,
    getRobotDilutionMlPerL,
} from '../../CleaningReportsDashboard/cleaningReportConsumptionUtils';
import RobotComparisonDashboardCard from '../../CleaningReportsDashboard/RobotComparisonDashboardCard';
import { calculateEfficiency } from './EfficiencyUtils';

const EXTRA_METRICS = [
    {
        value: 'efficiency',
        labelId:
            'page.robots.cleaning_report.robot_comparison.metrics.efficiency',
        fallback: 'Eficiência (m²/min)',
    },
    {
        value: 'battery_avg',
        labelId: 'page.robots.cleaning_report.robot_comparison.metrics.battery',
        fallback: 'Bateria média (%)',
    },
    {
        value: 'battery_per_100m2',
        labelId:
            'page.robots.cleaning_report.robot_comparison.metrics.battery_efficiency',
        fallback: 'Bateria / 100 m² (%)',
    },
    {
        value: 'water',
        labelId: 'page.robots.cleaning_report.robot_comparison.metrics.water',
        fallback: 'Água (L)',
    },
    {
        value: 'energy',
        labelId: 'page.robots.cleaning_report.robot_comparison.metrics.energy',
        fallback: 'Energia (kWh)',
    },
    {
        value: 'product',
        labelId: 'page.robots.cleaning_report.robot_comparison.metrics.product',
        fallback: 'Produto (ml)',
    },
];

export default function EfficiencyRobotComparisonCard({
    data,
    robotDilutions,
    list,
    ...rest
}) {
    const enhancedData = useMemo(() => {
        if (!data) return [];
        const withProduct = data.map(robotData => {
            const eff = calculateEfficiency(
                robotData.area,
                robotData.time * 60 * 60
            );
            const dilution = getRobotDilutionMlPerL(
                robotDilutions,
                robotData,
                list
            );
            const product = estimateRobotProductMl(robotData.water, dilution);

            return {
                ...robotData,
                efficiency: eff ? Number(eff.toFixed(2)) : 0,
                product,
            };
        });
        return mergeBatteryIntoRobotComparison(withProduct, list);
    }, [data, robotDilutions, list]);

    return (
        <RobotComparisonDashboardCard
            {...rest}
            data={enhancedData}
            extraMetrics={EXTRA_METRICS}
        />
    );
}

EfficiencyRobotComparisonCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    robotDilutions: PropTypes.arrayOf(
        PropTypes.shape({
            robot_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            sn: PropTypes.string,
            dilution_ml_per_l: PropTypes.number,
        })
    ),
    list: PropTypes.arrayOf(PropTypes.shape({})),
};

EfficiencyRobotComparisonCard.defaultProps = {
    data: [],
    robotDilutions: [],
    list: [],
};
